<template>
    <ss-modal
            v-show="modal"
            title="Title"
            v-if="guarantor"
            intro="bounceIn"
            outro ="bounceOut">
        <!-- HEADER -->
        <div slot = "modal-header">
            Poręczyciel <span class="text-primary">{{ guarantor.name }} {{ guarantor.surname }}</span>
        </div>
        <!-- BODY -->
        <div slot = "modal-body" class="text-center">
            <d-row>
                <d-col xs="5" class="text-right"><strong>Imię i nazwisko</strong></d-col>
                <d-col xs="5" offset-xs="6" class="text-left">{{ guarantor.name }} {{ guarantor.surname }}</d-col>
            </d-row>
            <hr>
<!--            <d-row>-->
<!--                <d-col xs="5" class="text-right"><strong>Nr telefonu</strong></d-col>-->
<!--                <d-col xs="5" offset-xs="6" class="text-left">{{ guarantor.phone ? guarantor.phone : '-' }}</d-col>-->
<!--            </d-row>-->
<!--            <hr>-->
            <d-row>
                <d-col xs="5" class="text-right"><strong>Nr telefonu</strong></d-col>
                <d-col xs="5" offset-xs="6" class="text-left">{{ guarantor.phone ? guarantor.phone : '-' }}</d-col>
            </d-row>
            <hr>
            <d-row>
                <d-col xs="5" class="text-right"><strong>Adres e-mail</strong></d-col>
                <d-col xs="5" offset-xs="6" class="text-left">{{ guarantor.email ? guarantor.email : '-' }}</d-col>
            </d-row>
            <hr>
            <d-row>
                <d-col xs="5" class="text-right"><strong>Adres</strong></d-col>
                <d-col xs="5" offset-xs="6" class="text-left">{{ guarantor.street }} {{ guarantor.house_number }} {{ guarantor.postcode }} {{ guarantor.city}}</d-col>
            </d-row>
            <hr>
            <d-row>
                <d-col xs="5" class="text-right"><strong>Typ dokumentu tożsamości</strong></d-col>
                <d-col xs="5" offset-xs="6" class="text-left">{{ getIdDocTypeLabel(guarantor.id_card_type) }}</d-col>
            </d-row>
            <hr>
            <d-row>
                <d-col xs="5" class="text-right"><strong>Nr dokumentu tożsamości</strong></d-col>
                <d-col xs="5" offset-xs="6" class="text-left">{{ guarantor.id_card || '-' }}</d-col>
            </d-row>
            <hr>
            <d-row>
                <d-col xs="5" class="text-right"><strong>Pesel</strong></d-col>
                <d-col xs="5" offset-xs="6" class="text-left">{{ guarantor.pesel || '-' }}</d-col>
            </d-row>
            <div v-if="guarantor.declaration_date">
                <h2 class="modal-table-separator">Egzekucja</h2>
                <d-row>
                    <d-col xs="5" class="text-right"><strong>Kwota</strong></d-col>
                    <d-col xs="5" offset-xs="6" class="text-left">{{ toNumber(guarantor.declaration_amount) }} zł</d-col>
                </d-row>
                <hr>
                <d-row>
                    <d-col xs="5" class="text-right"><strong>Data</strong></d-col>
                    <d-col xs="5" offset-xs="6" class="text-left">{{ guarantor.declaration_date }}</d-col>
                </d-row>
                <hr>
                <d-row>
                    <d-col xs="5" class="text-right"><strong>Dokument</strong></d-col>
                    <d-col xs="5" offset-xs="6" class="text-left">{{guarantor.declaration_doc ? guarantor.declaration_doc : '-'}}</d-col>
                </d-row>
                <hr>
            </div>
            <div v-if="guarantor.represented_by_proxy && guarantor.represented_by_proxy.toString() === '1'">
                <h2 class="modal-table-separator">Pełnomocnik</h2>
                <d-row>
                    <d-col xs="5" class="text-right"><strong>Imię i nazwisko</strong></d-col>
                    <d-col xs="5" offset-xs="6" class="text-left">{{ guarantor.proxy_name }} {{ guarantor.proxy_surname }}</d-col>
                </d-row>
                <hr>
                <d-row>
                    <d-col xs="5" class="text-right"><strong>Nr telefonu</strong></d-col>
                    <d-col xs="5" offset-xs="6" class="text-left">{{ guarantor.proxy_phone ? guarantor.proxy_phone : '-' }}</d-col>
                </d-row>
                <hr>
                <d-row>
                    <d-col xs="5" class="text-right"><strong>Nr telefonu</strong></d-col>
                    <d-col xs="5" offset-xs="6" class="text-left">{{ guarantor.proxy_phone ? guarantor.proxy_phone : '-' }}</d-col>
                </d-row>
                <hr>
                <d-row>
                    <d-col xs="5" class="text-right"><strong>Adres e-mail</strong></d-col>
                    <d-col xs="5" offset-xs="6" class="text-left">{{ guarantor.proxy_email ? guarantor.proxy_email : '-' }}</d-col>
                </d-row>
                <hr>
                <d-row>
                    <d-col xs="5" class="text-right"><strong>Adres</strong></d-col>
                    <d-col xs="5" offset-xs="6" class="text-left">{{ guarantor.proxy_street }} {{ guarantor.proxy_house_number }}{{ guarantor.proxy_flat_number ? '/' + guarantor.proxy_flat_number : '' }} {{ guarantor.proxy_postcode }} {{ guarantor.proxy_city}}</d-col>
                </d-row>
                <hr>
                <d-row>
                    <d-col xs="5" class="text-right"><strong>Typ dokumentu tożsamości</strong></d-col>
                    <d-col xs="5" offset-xs="6" class="text-left">{{ getIdDocTypeLabel(guarantor.proxy_id_card_type) }}</d-col>
                </d-row>
                <hr>
                <d-row>
                    <d-col xs="5" class="text-right"><strong>Nr dokumentu tożsamości</strong></d-col>
                    <d-col xs="5" offset-xs="6" class="text-left">{{ guarantor.proxy_id_card || '-' }}</d-col>
                </d-row>
                <hr>
                <d-row>
                    <d-col xs="5" class="text-right"><strong>Pesel</strong></d-col>
                    <d-col xs="5" offset-xs="6" class="text-left">{{ guarantor.proxy_pesel || '-' }}</d-col>
                </d-row>
            </div>
        </div>
        <!-- FOOTER -->
        <div slot = "modal-footer">
            <d-button @click.prevent="$emit('update:show', false)" theme="danger">Zamknij</d-button>
        </div>
    </ss-modal>
</template>

<script>
    import SsModal from '../common/SsModal';
    import IdDocumentsTypes from '@/data/id-documents-types.js';

    export default {
        name: "GuarantorModal",
        components: {
            SsModal
        },
        props: {
            props: {
                type: Object,
                default: ()=> {}
            },
            show: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                guarantor: null,
                modal: false,
                uid: null
            }
        },
        mounted(){
            this.modal = this.show;
            this.guarantor = this.props;
            this.uid = this._uid;
        },
        methods: {
          toNumber(number){
              return Vue.toNumber(number);
          },
          getIdDocTypeLabel (docType) {
            let docTypeFound = IdDocumentsTypes.find(item => item.value === docType);
            if (!docTypeFound) {
                docTypeFound = IdDocumentsTypes.find(item => item.defaultValue);
            }

            return docTypeFound ? docTypeFound.label : '-';
          }
        },
        watch: {
            props: {
                handler: function(to) {
                    this.guarantor = to;
                },
                deep: true
            },
            show(to) {
                this.modal = to;
            },
        }
    }
</script>

<style scoped>

</style>
